import angularDragDrop from "angular-drag-drop";
import "angular-drag-and-drop-lists";

import core from "@gtmhub/core/module";
import { ListService } from "./services/listService";
import { ListsCtrl } from "./controllers/lists";
import { ListCtrl } from "./controllers/list";
import { ListGrid } from "./directives/list-grid";
import { GoalApprovalStatusLabelComponent } from "./components/goal-approval-status-label.component";
import { ChartSettingsComponent } from "./components/chart-settings/chart-settings.component";
import { ListChartsComponent } from "./components/list-chart/list-chart.component";
import { ChartSettingsLoader } from "./services/chart-settings-loader";
import { ChartSettingsModalOpener } from "./services/chart-settings-modal-opener";
import { SaveListAsComponent } from "./components/save-list-as/save-list-as.component";

export default angular
  .module("lists", [core, angularDragDrop, "dndLists"])
  .service("ListService", ListService)
  .service("ChartSettingsLoader", ChartSettingsLoader)
  .service("ChartSettingsModalOpener", ChartSettingsModalOpener)
  .controller("ListCtrl", ListCtrl)
  .controller("ListsCtrl", ListsCtrl)
  .component("goalApprovalStatusLabel", GoalApprovalStatusLabelComponent)
  .component("chartSettings", ChartSettingsComponent)
  .component("listChart", ListChartsComponent)
  .component("saveListAs", SaveListAsComponent)
  .directive("listGrid", ListGrid.factory()).name;
